module.exports = __webpack_public_path__ + "61d85928158fc249f721add2d6a33576.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/service-icon-transact.png
// module id = 255
// module chunks = 1